import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../../../theme/color-palette';

const { PURPLE, TOGGLE_ACTIVE } = colors;
const styles = makeStyles(() => ({
	buttonContainer: {
		marginTop: '-47px',
		float: 'right',
		marginRight: '20px',
		'@media (min-width: 360px) and (max-width: 850px)': {
			marginTop: '-30px',
			marginRight: '10px',
		},
	},
	button: {
		textTransform: 'unset',
		backgroundColor: 'transparent',
		'&:hover': {
			background: TOGGLE_ACTIVE,
		},
		height: '32px',
		borderRadius: '60px',
	},
	buttonIcon: {
		height: '14px',
		color: PURPLE,
	},
	buttonLabel: {
		fontSize: '14px',
		fontWeight: 400,
		color: PURPLE,
		fontFamily: 'Bogle-Medium',
		cursor: 'pointer',
	},
}));

export default styles;
